import React from 'react';
import blogs1 from '../../../Assets/blog1.svg';
import blogs2 from '../../../Assets/blog2.svg';
import blogs3 from '../../../Assets/blog3 .svg';
import blogs4 from '../../../Assets/blog4.svg';
import coder1 from '../../../Assets/coder1.png';
import coder2 from '../../../Assets/coder2.png';
import './Blogs.css';


const Blogs = () => {
    return (
        <div className='container'>
            <div className="blogs-area clients-area">
                <h1 className='text-center pb-md-5'> Blogs</h1>
                <div className="row d-flex justify-content-around">
                    <div className="col-md-8 col-12">
                        <div className="row row-cols-1 row-cols-md-2 g-2">
                            <div className="col">
                                <div className="card border-0">
                                    <img src={blogs1} className="card-img-top" alt="..." />
                                    <span className='pb-0'>6 mins Read | 14 Aug, 2022 </span>
                                    <hr className='my-1' />
                                    <div className="card-body p-0">
                                        <h5 className="fw-bold">39 Websites That Can Make You Unbelieveably Smarter ...</h5>
                                        <div className='d-flex'>
                                            <img style={{ height: '30px' }} src={coder1} alt="" />
                                            <p className="fw-bold ps-3 pt-1">UX_BABA</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card border-0">
                                    <img src={blogs2} className="card-img-top" alt="..." />
                                    <span className='pb-0'>6 mins Read | 14 Aug, 2022 </span>
                                    <hr className='my-1' />
                                    <div className="card-body p-0">
                                        <h5 className="fw-bold">Deploying An Android App to AWS S3 With Cloud Front...</h5>
                                        <div className='d-flex'>
                                            <img style={{ height: '30px' }} src={coder2} alt="" />
                                            <p className="fw-bold ps-3 pt-1">BABA_CODER</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card border-0">
                                    <img src={blogs3} className="card-img-top" alt="..." />
                                    <span className='pb-0'>6 mins Read | 14 Aug, 2022 </span>
                                    <hr className='my-1' />
                                    <div className="card-body p-0">
                                        <h5 className="fw-bold">Creating A Next.js Project With Monorepo Using Learn...</h5>
                                        <div className='d-flex'>
                                            <img style={{ height: '30px' }} src={coder1} alt="" />
                                            <p className="fw-bold ps-3 pt-1">UX_BABA</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card border-0">
                                    <img src={blogs4} className="card-img-top" alt="..." />
                                    <span className='pb-0'>6 mins Read | 14 Aug, 2022 </span>
                                    <hr className='my-1' />
                                    <div className="card-body p-0">
                                        <h5 className="fw-bold">Rendering SVG Images in Next.js With Next Images And Bubble Plugin</h5>
                                        <div className='d-flex'>
                                            <img style={{ height: '30px' }} src={coder2} alt="" />
                                            <p className="fw-bold ps-3 pt-1">BABA_CODER</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 col-12 border ">
                        <h3 className='text-center pt-4'>Sponsor Ads</h3>
                        <div className="row d-flex flex-column  g-4 p-2 ">
                            <div className="col sponsor-box">
                                <div style={{backgroundColor:'whiteSmoke', height: '240px', width: '250px' }} className="card border-0">

                                </div>
                            </div>
                            <div className="col sponsor-box">
                                <div style={{backgroundColor:'whiteSmoke', height: '240px', width: '250px' }} className="card border-0">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blogs;